// extracted by mini-css-extract-plugin
module.exports = {"row":"SSPrinterCloud_row__2kKPA"};